<template>
  <div id="banner">
    <div class="banner-wrapper">
     <template v-if="$route.path == '/home'">
      <el-carousel :interval="5000"  height="600px">
      <!-- 有图片数据时显示接口返回的图片 -->
      <template v-if="bannerList.length > 0">
        <el-carousel-item v-for="(item, index) in bannerList" :key="index">
          <image-view :value="item.path" cusStyle="width: 100%; height: 600px; object-fit: cover;" />
        </el-carousel-item>
      </template>
      <!-- 没有图片数据时显示默认图片 -->
      <!-- <template v-else>
        <el-carousel-item>
          <img src="@/assets/img/2026/banner-swiper.png" alt="banner-bg" class="banner-img" />
        </el-carousel-item>
      </template> -->
      </el-carousel>
      </template>
      <template v-else>
         <image-view :value="bannerList[0].path" cusStyle="width: 100%; height: 380px; object-fit: cover;" />
      </template>
      <!-- 渐变遮罩层 -->
      <div class="banner-overlay"></div>
      <!-- 左侧文字内容 -->
      <div class="banner-content"  :style="type === 2 ? 'top: 0px;left: 207px' : 'top: 200px;left: 207px'">
       <slot>
         <img src="@/assets/img/2026/banner-text.png" alt="banner-content" />
       </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { getCarousel } from "@/api/index.js";
import imageView from "@/views/imageView.vue";

export default {
  name: "banner",
  components: { imageView },
  props: {
    type: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      bannerList: [],
      // 路由与轮播图类型的映射
      routeTypeMap: {
        '/home': 1,
        '/news': 5,
        '/products': 6,
        '/needs': 7,
        '/credit': 8,
        '/organ': 9,
        '/aboutUs': 10
      }
    };
  },
  computed: {
    /** 根据当前路由获取轮播图类型 */
    bannerType() {
      const path = this.$route.path;
      // 精确匹配或前缀匹配
      for (const [routePath, type] of Object.entries(this.routeTypeMap)) {
        if (path === routePath || path.startsWith(routePath + '/')) {
          return type;
        }
      }
      return 1; // 默认首页
    }
  },
  watch: {
    /** 监听路由变化，重新获取轮播图 */
    '$route.path'() {
      this.getBannerList();
    }
  },
  mounted() {
    this.getBannerList();
  },
  methods: {
    /** 获取轮播图列表 */
    getBannerList() {
      getCarousel({ type: this.bannerType }).then(res => {
        if (res.code === 1000) {
          this.bannerList = res.data.records || res.data || [];
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
#banner {
  width: 100%;
  position: relative;
}

.banner-wrapper {
  width: 100%;
  position: relative;
  overflow: hidden;
}

.banner-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* 背景图片占位区域 */
.banner-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f0f4f8;
  /* 实际使用时替换为真实图片 */
  /* background-image: url('~@/assets/images/banner-bg.jpg'); */
  /* background-size: cover; */
  /* background-position: center; */
}

/* 渐变遮罩层 - 从右到左白色渐变 */
.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.8) 30%,
    rgba(255, 255, 255, 0) 62%
  );
  z-index: 1;
}

/* 左侧文字内容区域 */
.banner-content {
  position: absolute;
  top: 280px;
  left: 207px;
  z-index: 2;
  max-width: 782px;
  width: 786px;
  img{
    width: 100%;
    height: 100%;
  }
}

.banner-title {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 70px;
  line-height: 16px;
  letter-spacing: 0.0171em;
  background: linear-gradient(
    90deg,
    rgba(92, 153, 255, 1) 0%,
    rgba(30, 110, 239, 1) 49%,
    rgba(133, 110, 250, 1) 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 46px 0;
}

.banner-subtitle {
  font-family: "PingFang SC", sans-serif;
  font-weight: 600;
  font-size: 36px;
  line-height: 16px;
  letter-spacing: 0.0333em;
  color: #183874;
  margin: 0 0 80px 0;
}

/* 标签列表 */
.banner-tags {
  display: flex;
  align-items: center;
  gap: 56px;
}

.tag-item {
  display: flex;
  align-items: center;
  gap: 9px;
}

.tag-icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #1366ec;
}

.tag-item span {
  font-family: "Noto Sans SC", sans-serif;
  font-weight: 400;
  font-size: 24px;
  line-height: 16px;
  letter-spacing: 0.05em;
  color: #183874;
}

/* 右侧装饰图片占位 */
.banner-decoration {
  position: absolute;
  top: 66px;
  right: 0;
  width: 2000px;
  height: 824px;
  background-color: #e8eef5;
  /* 实际使用时替换为真实图片 */
  /* background-image: url('~@/assets/images/banner-decoration.png'); */
  /* background-size: contain; */
  /* background-position: right center; */
  z-index: 0;
}
</style>
